import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer-certificado',
  templateUrl: './footer-certificado.component.html',
  styleUrls: ['./footer-certificado.component.css']
})
export class FooterCertificadoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
